import * as angular from "angular";
import { TalkingPointCategory } from "../../models/talking-point-category.model";
import { TalkingPoint } from "../../models/talking-point.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";
import { SearchUtils } from "../../helper/search.helper";
import { Utils } from "../../helper/utils.helper";
import { stringIncludedIgnoreCase } from "../../utils/string.utils";

let TalkingPointsComponent = {
    selector: "vcTalkingPoints",
    templateUrl:
        "/angular/components/talking-point/talking-points.component.html",
    bindings: {},
    controller: class TalkingPointsController {
        public supportUrl: string;
        public description: string;
        public subheading: string;
        public buttonText: string;
        public isLeaderView: boolean;
        public loading: boolean = true;
        public searchText: string = "";
        public categories: Array<TalkingPointCategory>;
        public searchIsMatching = false;

        private $scope: any;
        private __env: any;
        private $q: any;
        private dataProvider: TalkingPointDataProvider;
        private utils: Utils;
        public toast: ToastUtils;
        private dialog: DialogUtils;
        public permissionProvider: PermissionCheck;

        constructor(
            __app_type: string,
            $scope: any,
            __env: any,
            $q: any,
            SearchUtils: SearchUtils,
            DialogUtils: DialogUtils,
            TalkingPointDataProvider: TalkingPointDataProvider,
            Utils: Utils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dataProvider = TalkingPointDataProvider;
            this.utils = Utils;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.$q = $q;
            this.permissionProvider = PermissionCheck;

            this.utils.accessCheck();
            this.utils.runWootric();
            this.supportUrl =
                "https://support." +
                this.__env.product +
                ".com/your-dashboard/teams-and-analytics/understanding-your-talking-points-page";
            this.description =
                "Share key updates and messages with your field organizers";
            this.isLeaderView = __app_type === "LEADER";

            if (this.permissionProvider.hasPermission("EDIT_TALKING_POINT")) {
                this.subheading =
                    "Create your first talking point which will populate on the mobile app to provide instructions or messaging to organizers in the field";
                this.buttonText = "Create Talking Point";
            }

            this.dataProvider.getCategories().then(
                (categories) => {
                    this.loading = false;
                    this.categories = categories;
                },
                () => {
                    this.loading = false;
                    this.toast.error();
                }
            );

            SearchUtils.setSearchBar("Search Talking Points", (searchText) => {
                this.searchText = searchText;
                return this.$q.resolve([]);
            });

            this.$scope.$watch(
                () => this.searchText,
                (newValue: string, oldValue: string) => {
                    if (!oldValue || newValue === oldValue) return;

                    this.checkSearchIsMatching();
                }
            );
        }

        checkSearchIsMatching(): void {
            this.searchIsMatching = false;
            angular.forEach(this.categories, (category) => {
                if (
                    stringIncludedIgnoreCase(category.tpcname, this.searchText)
                ) {
                    this.searchIsMatching = true;
                    return;
                }

                angular.forEach(category.points, (point) => {
                    if (
                        stringIncludedIgnoreCase(point.tpname, this.searchText)
                    ) {
                        this.searchIsMatching = true;
                        return;
                    }
                });
            });
        }

        stringIsMatchingSearch(stringValue: string): boolean {
            return stringIncludedIgnoreCase(stringValue, this.searchText);
        }

        isEditable(point) {
            return (
                this.permissionProvider.hasPermission("EDIT_TALKING_POINT") &&
                (this.isLeaderView || !point.otpid)
            );
        }

        openTalkingPointDialog(point, category, onlyTeam, ev) {
            this.dialog
                .show({
                    component: "vc-create-talking-point",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedPoint: point,
                        selectedCategory: category,
                        onlyTeam: onlyTeam,
                    },
                })
                .then((pointEdited) => {
                    if (point) {
                        this.dataProvider
                            .updatePoint(pointEdited, point)
                            .then(() => {
                                point.setData(pointEdited);
                                this.toast.success("Point updated");
                            }, this.toast.error);
                    } else {
                        this.dataProvider
                            .createPoint(pointEdited)
                            .then(
                                this.toast.success("Point created"),
                                this.toast.error
                            );
                    }
                });
        }

        openDeletePointDialog(point, category, ev) {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: "Delete Talking Point?",
                    },
                })
                .then(() => {
                    this.dataProvider.deletePoint(point, category).then(
                        () => {
                            this.toast.success("Point deleted");
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("talkingPoint")
    .component(TalkingPointsComponent.selector, TalkingPointsComponent);
